import React, { useEffect, useState } from "react";
import style from "./style.module.css";
import LogoPanah from "../../Picture/panah.png";
import { useNavigate } from "react-router-dom";

const OwnerDatabase = (props) => {
  const today = new Date().toISOString().split("T")[0];
  const [tanggalAwal, setTanggalAwal] = useState("");
  const [tanggalAkhir, setTanggalAkhir] = useState("");
   const [tanggalAwalAttendance, setTanggalAwalAttendance] = useState("");
  const [tanggalAkhirAttendance, setTanggalAkhirAttendance] = useState("");
  const [nilaiPemasukan, setNilaiPemasukan] = useState(0);
  const [nilaiPengeluaran, setNilaiPengeluaran] = useState(0);
  const [nilaiSaldo, setNilaiSaldo] = useState(0);
  const [totalKaryawan, setTotalKaryawan] = useState(0);
  const [totalTrainer, setTotalTrainer] = useState(0);
  const [totalMemberAktif, setTotalMemberAktif] = useState(0);
  const [totalMemberExpired, setTotalMemberExpired] = useState(0);
  const [totalMember1, setTotalMember1] = useState(0);
  const [totalMember2, setTotalMember2] = useState(0);
  const [totalFreelance1, setTotalFreelance1] = useState(0);
  const [totalFreelance2, setTotalFreelance2] = useState(0);
  const [dataDetailCashflowGym1, setDataDetailCashflowGym1] = useState([]);
  const [dataDetailCashflowGym2, setDataDetailCashflowGym2] = useState([]);
  const [selectFilter, setSelectFilter] = useState("all");
  const [jsonDataDetail1, setJsonDataDetail1] = useState([]);
  const [jsonDataDetail2, setJsonDataDetail2] = useState([]);
  const [pilihanKiri, setPilihanKiri] = useState("visitor");
  const [dataDetailVisitorGym1, setDataDetailVisitorGym1] = useState([]);
  const [dataDetailVisitorGym2, setDataDetailVisitorGym2] = useState([]);
  const [dataDetailKaryawanDanTrainer,setDataDetailKaryawanDanTrainer]=useState([]);
  const [dataDetailMember,setDataDetailMember]=useState([]);
  const [dataDetailAttendanceKaryawanDanTrainer,setDataDetailAttendanceKaryawanDanTrainer]=useState([]);
  const [dataDetailJamKaryawanDanTrainer,setDataDetailJamKaryawanDanTrainer]=useState([]);
  const [isSessionValid, setIsSessionValid] = useState(false);

  const url = props.url;
  const navigate=useNavigate("");


  // format jam menit
  function formatJamMenit(diffJam) {
  const jam = Math.floor(diffJam);
  const menit = Math.round((diffJam - jam) * 60);
  return `${jam} jam ${menit} menit`;
}

//function data detail attendance karyawan dan trainer
  const GetDaftarHadirKaryawanGym = () => {
    fetch(url + "/?op=getDaftarHadirKaryawanGym", {
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body:
        "dateStart=" +
        tanggalAwalAttendance +
        " 00:00:00" +
        "&dateFinish=" +
        tanggalAkhirAttendance +
        " 23:59:59",
    })
      .then((response) => response.json())
      .then((json)=>{
        if(json!==null){
setDataDetailAttendanceKaryawanDanTrainer(json);
const result = {};

  json.forEach((item) => {
    if (!result[item.nama]) {
      result[item.nama] = {
        nama: item.nama,
        tidakScan: 0,
        scan: 0,
        totalJamScan: 0,
      };
    }

    if (item.jam_datang && !item.jam_pulang) {
      // kasus tidak scan
      result[item.nama].tidakScan += 1;
    } else if (item.jam_datang && item.jam_pulang) {
      // kasus scan
      result[item.nama].scan += 1;

      // hitung jam
     if (item.jam_datang && item.jam_pulang) {
  const datang = new Date(item.jam_datang);
  const pulang = new Date(item.jam_pulang);

  if (!isNaN(datang) && !isNaN(pulang)) {
    const diffJam = (pulang - datang) / (1000 * 60 * 60); // selisih dalam jam (decimal)
    result[item.nama].totalJamScan += diffJam;
  }
}
    }
  });
setDataDetailJamKaryawanDanTrainer(Object.values(result));
  //return Object.values(result); // ubah ke array

        }
        else{
          setDataDetailAttendanceKaryawanDanTrainer([]);
        }
      })
    }
  // function KlikDataId
  const KlikKiri = (value) => {
    setPilihanKiri(value);
  };

  // function ambil data all history
  const GetDataAllHistoryPengeluaranInventoryGym = () => {
    fetch(url + "/?op=getDataAllHistoryPengeluaranInventoryGym", {
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body:
        "dateStart=" +
        tanggalAwal +
        " 00:00:00" +
        "&dateFinish=" +
        tanggalAkhir +
        " 23:59:59",
    })
      .then((response) => response.json())
      .then((json) => {
        if (json !== null) {
          setJsonDataDetail1(json);
          const income = json
            .filter((item) => item.keterangan === "income")
            .reduce((acc, item) => acc + parseInt(item.total), 0);
          const outcome = json
            .filter((item) => item.keterangan === "outcome")
            .reduce((acc, item) => acc + parseInt(item.total), 0);
          const saldo = income - outcome;
          setDataDetailCashflowGym1(json);
          setNilaiPemasukan(income);
          setNilaiPengeluaran(outcome);
          setNilaiSaldo(saldo);
        } else {
          setDataDetailCashflowGym1([]);
          setNilaiPemasukan(0);
          setNilaiPengeluaran(0);
          setNilaiSaldo(0);
        }
      });
  };

  // function select filter
  const SelectFilter = (value) => {
    setSelectFilter(value);

    if (value === "income") {
      setDataDetailCashflowGym1(
        jsonDataDetail1.filter((item) => item.keterangan == "income")
      );
      setDataDetailCashflowGym2(
        jsonDataDetail2.filter((item) => item.keterangan == "income")
      );
    } else if (value === "outcome") {
      setDataDetailCashflowGym1(
        jsonDataDetail1.filter((item) => item.keterangan === "outcome")
      );
      setDataDetailCashflowGym2(
        jsonDataDetail2.filter((item) => item.keterangan === "outcome")
      );
    } else {
      setDataDetailCashflowGym1(
        jsonDataDetail1.filter(
          (item) =>
            item.keterangan === "income" || item.keterangan === "outcome"
        )
      );
      setDataDetailCashflowGym2(
        jsonDataDetail2.filter(
          (item) =>
            item.keterangan === "income" || item.keterangan === "outcome"
        )
      );
    }
  };
  // fucntion Get database kartu gym
  const GetDatabaseKartuGym = async () => {
    await fetch(url + "/?op=getDatabaseKartuGym")
      .then((response) => response.json())
      .then((json) => {
        if (json !== null) {
          const filterMemberAktif = json.filter(
            (item) =>
              today <= item.expired_member &&
              (item.status === "Member Umum" ||
                item.status === "Member Pelajar")
          );
          const filterMemberExpired = json.filter(
            (item) =>
              today > item.expired_member &&
              (item.status === "Member Umum" ||
                item.status === "Member Pelajar")
          );
          const karyawan = json.filter((item) => item.status === "Karyawan");
          const trainer = json.filter((item) => item.status === "Trainer");
          setDataDetailKaryawanDanTrainer(json.filter((item)=>item.status === "Karyawan" || item.status==="Trainer"));
          setDataDetailMember(
  json
    .filter(
      (item) =>
        item.status === "Member Umum" || item.status === "Member Pelajar"
    )
    .sort((a, b) => new Date(b.expired_member) - new Date(a.expired_member))
);

          setTotalMemberAktif(filterMemberAktif.length);
          setTotalMemberExpired(filterMemberExpired.length);
          setTotalKaryawan(karyawan.length);
          setTotalTrainer(trainer.length);
        } else {
          setTotalMemberAktif(0);
          setTotalMemberExpired(0);
          setTotalKaryawan(0);
          setTotalTrainer(0);
        }
      });
  };
  // fucntion GetDataPengunjungGymWithTwoDate
  const GetDataPengunjungGymWithTwoDate = () => {
    fetch(url + "/?op=getDataPengunjungGymWithTwoDate", {
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body:
        "dateStart=" +
        tanggalAwal +
        " 00:00:00" +
        "&dateFinish=" +
        tanggalAkhir +
        " 23:59:59",
    })
      .then((response) => response.json())
      .then((json) => {
        if (json !== null) {
          setTotalFreelance1(
            json.filter((item) => item.status === "Freelance").length
          );
          setTotalMember1(
            json.filter(
              (item) =>
                item.status === "Member Pelajar" ||
                item.status === "Member Umum"
            ).length
          );
          setDataDetailVisitorGym1(json);
        } else {
          setTotalFreelance1(0);
          setTotalMember1(0);
          setDataDetailVisitorGym1([]);
        }
      });
  };
  // fucntion GetDataPengunjungGym2WithTwoDate
  const GetDataPengunjungGym2WithTwoDate = () => {
    fetch(url + "/?op=getDataPengunjungGym2WithTwoDate", {
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body:
        "dateStart=" +
        tanggalAwal +
        " 00:00:00" +
        "&dateFinish=" +
        tanggalAkhir +
        " 23:59:59",
    })
      .then((response) => response.json())
      .then((json) => {
        if (json !== null) {
          setTotalFreelance2(
            json.filter((item) => item.status === "Freelance").length
          );
          setTotalMember2(
            json.filter(
              (item) =>
                item.status === "Member Pelajar" ||
                item.status === "Member Umum"
            ).length
          );
          setDataDetailVisitorGym2(json);
        } else {
          setTotalFreelance2(0);
          setTotalMember2(0);
          setDataDetailVisitorGym2([]);
        }
      });
  };
  // ====== CEK SESSION SEKALI DI AWAL ======
  useEffect(() => {
    fetch(url + "/?op=cekSession", { credentials: "include" })
      .then((res) => res.json())
      .then((json) => {
        if (json === "kosong") {
          navigate("/", { replace: true });
        } else if (json === "gym2") {
          navigate("/gym2", { replace: true });
        } else if (json === "gym1") {
          navigate("/gym1", { replace: true });
        } else {
          // hanya valid kalau bukan kosong/gym1/gym2
          setIsSessionValid(true);
        }
      })
      .catch((err) => console.error("Error cekSession:", err));
  }, [navigate]);

  // ====== SET DEFAULT TANGGAL SEKALI DI AWAL ======
  useEffect(() => {
    setTanggalAwal(today);
    setTanggalAkhir(today);
    setTanggalAwalAttendance(today);
    setTanggalAkhirAttendance(today);
  }, [today]);

  // ====== LOAD DATA HANYA KALAU SESSION VALID ======
  useEffect(() => {
    if (isSessionValid) {
      GetDatabaseKartuGym();
      GetDaftarHadirKaryawanGym();
    }
  }, [isSessionValid]);

  // ====== FETCH DATA VISITOR SAAT TANGGAL BERUBAH ======
  useEffect(() => {
    if (isSessionValid && tanggalAwal && tanggalAkhir) {
      GetDataPengunjungGymWithTwoDate();
      GetDataPengunjungGym2WithTwoDate();
    }
  }, [tanggalAwal, tanggalAkhir, isSessionValid]);

  // ====== FETCH DATA ATTENDANCE SAAT TANGGAL BERUBAH ======
  useEffect(() => {
    if (isSessionValid && tanggalAwalAttendance && tanggalAkhirAttendance) {
      GetDaftarHadirKaryawanGym();
    }
  }, [tanggalAwalAttendance, tanggalAkhirAttendance, isSessionValid]);
  /*
  //
  useEffect(() => {
    setTanggalAwal(today);
    setTanggalAkhir(today);
    setTanggalAwalAttendance(today);
    setTanggalAkhirAttendance(today);
    GetDatabaseKartuGym();
    GetDataPengunjungGymWithTwoDate();
    GetDataPengunjungGym2WithTwoDate();
    GetDaftarHadirKaryawanGym();
  }, []);
  // useEffect perubahan tanggal
  useEffect(() => {
    GetDataPengunjungGymWithTwoDate();
    GetDataPengunjungGym2WithTwoDate();
  }, [tanggalAwal, tanggalAkhir]);
    // useEffect perubahan tanggal attendance karyawan dan trainer
  useEffect(() => {
    GetDaftarHadirKaryawanGym();
  }, [tanggalAwalAttendance, tanggalAkhirAttendance]);
   // use effect cek session
        useEffect(()=>{
                fetch(url + "/?op=cekSession", {
                    credentials: "include", 
                  })
                  .then((response)=>response.json())
                  .then((json)=>{
                   
                  if (json === "kosong") {
                        navigate("/", { replace: true });
                      }else if(json ==="gym2"){
            navigate("/gym2", { replace: true });
                      }else if(json ==="gym1"){
            navigate("/gym1", { replace: true });
                      }
                  })
                },[])
                */
  return (
    <div className={style.containerAll}>
      <div className={style.containerKiri}>
        <div
          onClick={() => KlikKiri("dataId")}
          style={{
            cursor: "pointer",
            borderBottom: pilihanKiri === "dataId" ? "solid 1px blue" : "",
            color: pilihanKiri === "dataId" ? "blue" : "",
          }}
          className={style.divJudulContainerKiri}
        >
          Data Id Card
        </div>
        <div className={style.divTabelContainerKiri}>
          <table className={style.tabel}>
            <thead>
              <tr>
                <th>Subjek</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Karyawan</td>
                <td>{totalKaryawan}</td>
              </tr>
              <tr>
                <td>Trainer</td>
                <td>{totalTrainer}</td>
              </tr>
              <tr>
                <td>Member Aktif</td>
                <td>{totalMemberAktif}</td>
              </tr>
              <tr>
                <td>Member Expired</td>
                <td>{totalMemberExpired}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div
          onClick={() => KlikKiri("visitor")}
          style={{
            cursor: "pointer",
            borderBottom: pilihanKiri === "visitor" ? "solid 1px blue" : "",
            color: pilihanKiri === "visitor" ? "blue" : "",
          }}
          className={`${style.divJudulContainerKiri} ${style.divJudulContainerKiriVisitor}`}
        >
          Visitor
        </div>
        <div className={style.divTanggal}>
          <input
            style={{ cursor: "pointer" }}
            value={tanggalAwal}
            type="date"
            onChange={(e) => {
              setTanggalAwal(e.target.value);
            }}
          />
          <div>
            <img src={LogoPanah} />
          </div>

          <input
            style={{ cursor: "pointer" }}
            value={tanggalAkhir}
            type="date"
            onChange={(e) => {
              setTanggalAkhir(e.target.value);
            }}
          />
        </div>
        <div className={style.divTabelContainerKiri}>
          <table className={style.tabel}>
            <thead>
              <tr>
                <th>Subjek</th>
                <th>Total Gym 1</th>
                <th>Total Gym 2</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Member</td>
                <td>{totalMember1}</td>
                <td>{totalMember2}</td>
              </tr>
              <tr>
                <td>Freelance</td>
                <td>{totalFreelance1}</td>
                <td>{totalFreelance2}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div
        style={{ display: pilihanKiri === "visitor" ? "block" : "none" }}
        className={style.containerKanan}
      >
        <div className={`${style.divIsiContainerKanan} ${style.divIsiVisitor}`}>
          <div className={style.divIsiContainerKananKiriVisitor}>
            <div>Attendance Gym 1</div>
            <div>
              <table className={style.tabelContainerKanan}>
                <thead>
                  <tr>
                    <th>Timestamp</th>
                    <th>Nama</th>

                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {dataDetailVisitorGym1.map((item, index) => (
                    <tr key={index}>
                      <td>{item.timestamp}</td>
                      <td>{item.nama}</td>

                      <td>{item.status}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className={style.divIsiContainerKananKananVisitor}>
            <div>Attendance Gym 2</div>
            <div>
              <table className={style.tabelContainerKanan}>
                <thead>
                  <tr>
                    <th>Timestamp</th>
                    <th>Nama</th>

                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {dataDetailVisitorGym2.map((item, index) => (
                    <tr key={index}>
                      <td>{item.timestamp}</td>
                      <td>{item.nama}</td>

                      <td>{item.status}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{ display: pilihanKiri === "dataId" ? "block" : "none" }}
        className={style.containerKanan}
      >
        <div className={`${style.divIsiContainerKanan} ${style.divIsiVisitor}`}>
          <div className={style.divIsiContainerKananKiri}>
<div className={style.divIsiContainerKananKiriAtas}>
            <div>Database Karyawan & Trainer</div>
            <div>
              <table className={style.tabelContainerKanan}>
                <thead>
                  <tr>
                    <th>Nama</th>
                    <th>Alamat</th>

                    <th>Nomor Hp</th>
                     <th>Status</th>
                         <th>Tgl Bergabung</th>
                  </tr>
                </thead>
                <tbody>
                  {dataDetailKaryawanDanTrainer.map((item, index) => (
                    <tr key={index}>
                      <td>{item.nama}</td>
                      <td>{item.alamat}</td>

                      <td>{item.nomor_hp}</td>
                      <td>{item.status}</td>
                        <td>{item.awal_pendaftaran}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className={style.divIsiContainerKananKiriBawah}>
            <div>Database Member</div>
            <div>
              <table className={style.tabelContainerKanan}>
                <thead>
                  <tr>
                    <th>Nama</th>
                    <th>Alamat</th>

                    <th>Nomor Hp</th>
                     <th>Status</th>
                         <th>Tgl Bergabung</th>
                           <th>Start Member</th>
                             <th>Expired Member</th>
                  </tr>
                </thead>
                <tbody>
                  {dataDetailMember.map((item, index) => (
                    <tr style={{color:item.expired_member<= today?"red":""}} key={index}>
                      <td>{item.nama}</td>
                      <td>{item.alamat}</td>

                      <td>{item.nomor_hp}</td>
                      <td>{item.status}</td>
                        <td>{item.awal_pendaftaran}</td>
                                <td>{item.start_member}</td>
                                        <td>{item.expired_member}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          </div>
          
          <div className={style.divIsiContainerKananKanan}>
           <div className={style.divIsiContainerKananKananAtas}>
            <div className={style.judulIsiContainerKananKananAtas}>Attendance Karyawan & Trainer</div>
            <div className={style.divTanggalIsiContainerKananKananAtas}>
          <input
            style={{ cursor: "pointer" }}
            value={tanggalAwalAttendance}
            type="date"
            onChange={(e) => {
              setTanggalAwalAttendance(e.target.value);
            }}
          />
          <div>
            <img src={LogoPanah} />
          </div>

          <input
            style={{ cursor: "pointer" }}
            value={tanggalAkhirAttendance}
            type="date"
            onChange={(e) => {
              setTanggalAkhirAttendance(e.target.value);
            }}
          />
        </div>
            <div className={style.tabelIsiContainerKananKananAtas}>
              <table className={style.tabelContainerKanan}>
                <thead>
                  <tr>
                    <th>Nama</th>
             

                     <th>Jam Datang</th>
                         <th>Jam Pulang</th>
                  </tr>
                </thead>
                <tbody>
                  {dataDetailAttendanceKaryawanDanTrainer.map((item, index) => (
                    <tr key={index}>
                      <td>{item.nama}</td>
                      <td>{item.jam_datang}</td>

                      <td>{item.jam_pulang}</td>
               
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className={style.divIsiContainerKananKananBawah}>
            <div className={style.judulIsiContainerKananKananBawah}>Total Jam Karyawan & Trainer</div>
           
            <div className={style.tabelIsiContainerKananKananBawah}>
              <table className={style.tabelContainerKanan}>
                <thead>
                  <tr>
                    <th>Nama</th>
             

                     <th>Tidak Scan</th>
                         <th>Scan</th>
                         <th>Total Jam Scan</th>
                  </tr>
                </thead>
                <tbody>
                  {dataDetailJamKaryawanDanTrainer.map((item, index) => (
                    <tr key={index}>
                      <td>{item.nama}</td>
                      <td>{item.tidakScan}</td>

                      <td>{item.scan}</td>
                        <td>{formatJamMenit(item.totalJamScan)}</td>
               
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default OwnerDatabase;
